import { render, staticRenderFns } from "./ElFieldPhone.vue?vue&type=template&id=20eabc36"
import script from "./ElFieldPhone.vue?vue&type=script&lang=js"
export * from "./ElFieldPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports